import { render, staticRenderFns } from "./RegistroFichas.vue?vue&type=template&id=a98cfc88&scoped=true&"
import script from "./RegistroFichas.vue?vue&type=script&lang=js&"
export * from "./RegistroFichas.vue?vue&type=script&lang=js&"
import style0 from "./RegistroFichas.vue?vue&type=style&index=0&id=a98cfc88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98cfc88",
  null
  
)

export default component.exports